import { equals } from 'ramda';
import { AppState, AppStateStatus, Platform } from 'react-native';
import {
  BehaviorSubject,
  fromEvent,
  map,
  mapTo,
  merge,
  Observable,
} from 'rxjs';
import { useCreateObservable } from '../rxReact/useCreateObservable';
import { useLocalObservable } from '../rxReact/useLocalObservable';

export const appState$: BehaviorSubject<AppStateStatus> = (() => {
  if (process.env.NODE_ENV === 'test') {
    return new BehaviorSubject<AppStateStatus>('active');
  }

  const subject = new BehaviorSubject(AppState.currentState);

  AppState.addEventListener('change', (state: AppStateStatus) =>
    subject.next(state),
  );

  return subject;
})();

export const browserWindowState$: BehaviorSubject<'focused' | 'blurred'> =
  (() => {
    if (process.env.NODE_ENV === 'test') {
      return new BehaviorSubject<'focused' | 'blurred'>('focused');
    }

    const subject = new BehaviorSubject<'focused' | 'blurred'>('focused');

    if (Platform.OS === 'web') {
      merge(
        fromEvent(window, 'focus').pipe(mapTo('focused' as const)),
        fromEvent(window, 'blur').pipe(mapTo('blurred' as const)),
      ).subscribe(subject);
    }

    return subject;
  })();

export const useAppState = (): AppStateStatus => {
  return useLocalObservable(() => appState$, [], appState$.value);
};

export const useIsAppActive = (): boolean => {
  return useAppState() === 'active';
};

export const useIsAppActive$ = (): Observable<boolean> => {
  return useCreateObservable(
    () => appState$.pipe(map(equals<AppStateStatus>('active'))),
    [],
    [],
  );
};
